// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__17Trp","approved":"Status_approved__2U4wf","rejected":"Status_rejected__o3xTb","expired":"Status_expired__1_Y6y","label":"Status_label__1mVuL"};